<!-- @if (type === 'bar') {
<div class="bar-wrapper">
    @for (bar of bars; track $index) {
        <div class="d-flex flex-column align-items-center">
            <div class="bar-vertical" [style.height.%]="bar.height"></div>
            <div class="bar-label">{{ bar.label }}</div>
        </div>
    }
</div>
}
@else {
    @for (item of rowArray; track $index) { -->
    <ng-container *ngFor="let item of rowArray; let $index = index">
        <div class="skeleton-loader" [ngStyle]="{
            width: width,
            height: height,
            borderRadius: borderRadius,
            minHeight: '40px'
        }" [ngClass]="{'mt-2': $index > 0}"></div>
    </ng-container>
    <!-- }
} -->